<template>
	<!-- Begin Page Content -->
        <div class="container-fluid">
          <div class="row justify-content-between">
            <div class="col text-center">
              <h3 class="h3 mb-2 text-gray-800">Сургуулийн данс</h3>
            </div>
            
          </div>
          <!-- Page Heading -->

		 
          <!-- DataTales Example -->
          <div class="card shadow my-4" >
            <div class="card-header row m-0">
              <div class="col">
                <h4></h4>
              </div>


            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th >Нэр</th>
                      <th>Дугаар</th>
                      <th>Төлөв</th>
                      <th>Боломжит үлдэгдэл</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(account , index) in accounts">
                      <td>{{index+1}}. </td>
                      <td>
                        {{account.name}}
                      </td>
                      <td>
                        {{account.number}}
                      </td>
                      <td>
                        {{account.status}}
                      </td>
                      <td>
                        {{formatPrice(account.avalaibleBalance)}}
                      </td>
                      <td>
                        <button class="btn btn-sm btn-primary" @click="$router.push({ name:'AccountTransaction', params:{ accountNumber:account.number } })">Дэлгэрэнгүй</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <div v-else class="alert alert-info text-center">Та {{semester.title}} семестерт ямар нэгэн хичээл оруулаагүй байна.</div> -->
              </div>
            </div>
          </div>
          <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
              <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-success" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-danger" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-warning" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-info" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-dark" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
          </div>
        </div>
        <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../firebaseConfig.js')
import Vue from 'vue'
import { mapState } from "vuex";
import { currentUser } from '../../firebaseConfig.js';
import moment from 'moment';
import accountinfo from './accountinfo.js';
export default {
  name: "Accounts",
  data() {
    return {
      msg: "Hellow",
      accounts:[],
      loading:false
    };
  },
  mixins: [accountinfo],
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    
      this._getLessons();
    
  },
   methods: {
    async _getLessons(){
      this.loading=true;
      try{
        await this._getToken();
        var result=await this._getAccount();
        if(result && result.accounts){
          this.accounts=result.accounts;
        }
      }
      catch(e){

      }
      this.loading=false;
    },
		
    goDetail(lesson){
      // if(lesson.isBlock!=true && (lesson.school==null || lesson.department==null || lesson.program==null)){
      //   alert("Та эхлээд хичээлийнхээ сургууль , тэнхим болон хөтөлбөрийг сонгоно уу");
      //   this.$router.push({ name: 'LessonEdit', params: { lessonId: lesson.id} });
      // }
      // else
        this.$router.push({ name: 'LessonDetailAdmin', params: { lessonId: lesson.id} })
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

	},
	filters: {
		formatDate(val) {
			if (!val) { return '-' }
			let date = val.toDate()
			return moment(date).fromNow()
		},
	
	}
};
</script>